module.exports = __webpack_public_path__ + "static/media/1POLICY23.c5f0cc17.jpg";